import React from 'react';
import { PageTitle } from '../components/PageTitle';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
export function TermsAndConditions() {
  return <div className="bg-white min-h-screen" data-id="element-1465">
      <PageTitle title="Terms & Conditions" canonical="/terms" description="Terms and conditions for using Katalina Bock's professional portfolio website." keywords="terms and conditions, legal terms, website usage, Katalina Bock, legal agreement" data-id="element-1466" />
      <Helmet data-id="element-1467">
        <script type="application/ld+json" data-id="element-1468">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Terms & Conditions',
          description: "Terms and conditions for using Katalina Bock's professional portfolio website."
        })}
        </script>
      </Helmet>
      <section className="bg-gradient-to-r from-[#E0F5F8] to-[#F0FAFC] text-gray-900 py-12" data-id="element-1469">
        <div className="container mx-auto px-4" data-id="element-1470">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1471">Terms & Conditions</h1>
          <p className="text-base text-gray-700" data-id="element-1472">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </section>
      <section className="container mx-auto px-4 py-12" data-id="element-1473">
        <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1474">
          <h2 data-id="element-1475">1. Agreement to Terms</h2>
          <p data-id="element-1476">
            By accessing and using this website (katalinabock.com), you accept
            and agree to be bound by the terms and provisions of this agreement.
            If you do not agree to abide by these terms, please do not use this
            website.
          </p>
          <h2 data-id="element-1477">2. Intellectual Property Rights</h2>
          <p data-id="element-1478">
            Unless otherwise stated, Katalina Bock owns the intellectual
            property rights for all material on this website. All intellectual
            property rights are reserved. You may view and/or print pages from
            this website for your own personal use subject to restrictions set
            in these terms and conditions.
          </p>
          <p data-id="element-1479">You must not:</p>
          <ul data-id="element-1480">
            <li data-id="element-1481">Republish material from this website</li>
            <li data-id="element-1482">Sell, rent, or sub-license material from this website</li>
            <li data-id="element-1483">Reproduce, duplicate, or copy material from this website</li>
            <li data-id="element-1484">
              Redistribute content from this website, unless content is
              specifically made for redistribution
            </li>
          </ul>
          <h2 data-id="element-1485">3. User Content</h2>
          <p data-id="element-1486">
            In these terms and conditions, "User Content" means material
            (including without limitation text, images, audio material, video
            material, and audio-visual material) that you submit to this
            website, for whatever purpose.
          </p>
          <p data-id="element-1487">
            You grant Katalina Bock a worldwide, irrevocable, non-exclusive,
            royalty-free license to use, reproduce, adapt, publish, translate,
            and distribute your User Content in any existing or future media.
            You also grant Katalina Bock the right to sub-license these rights
            and the right to bring an action for infringement of these rights.
          </p>
          <h2 data-id="element-1488">4. Limitations of Liability</h2>
          <p data-id="element-1489">
            Katalina Bock will not be liable for any loss or damage related to
            the use of this website. This includes without limitation:
          </p>
          <ul data-id="element-1490">
            <li data-id="element-1491">any indirect, special, or consequential loss or damage</li>
            <li data-id="element-1492">any loss of business, income, revenue, or profits</li>
            <li data-id="element-1493">any loss of contracts or business relationships</li>
            <li data-id="element-1494">any loss of reputation</li>
            <li data-id="element-1495">any loss of data</li>
            <li data-id="element-1496">any loss or damage arising from business interruption</li>
          </ul>
          <h2 data-id="element-1497">5. Acceptable Use</h2>
          <p data-id="element-1498">
            You must not use this website in any way that causes, or may cause,
            damage to the website or impairment of the availability or
            accessibility of the website, or in any way which is unlawful,
            illegal, fraudulent, or harmful.
          </p>
          <p data-id="element-1499">
            You must not use this website to copy, store, host, transmit, send,
            use, publish, or distribute any material which consists of (or is
            linked to) any spyware, computer virus, Trojan horse, worm,
            keystroke logger, rootkit, or other malicious computer software.
          </p>
          <h2 data-id="element-1500">6. Restricted Access</h2>
          <p data-id="element-1501">
            Katalina Bock reserves the right to restrict access to areas of this
            website, or indeed this entire website, at her discretion. If
            Katalina Bock provides you with a user ID and password to enable you
            to access restricted areas of this website or other content or
            services, you must ensure that the user ID and password are kept
            confidential.
          </p>
          <h2 data-id="element-1502">7. Links to Other Websites</h2>
          <p data-id="element-1503">
            This website may contain links to other websites. Unless expressly
            stated, these sites are not under the control of Katalina Bock.
            Katalina Bock assumes no responsibility for the content of such
            websites and disclaims liability for any and all forms of loss or
            damage arising out of the use of them.
          </p>
          <h2 data-id="element-1504">8. Variations</h2>
          <p data-id="element-1505">
            Katalina Bock may revise these terms and conditions from time to
            time. Revised terms and conditions will apply to the use of this
            website from the date of their publication. Please check this page
            regularly to ensure you are familiar with the current version.
          </p>
          <h2 data-id="element-1506">9. Governing Law</h2>
          <p data-id="element-1507">
            These terms and conditions are governed by and construed in
            accordance with the laws of the United States, and you submit to the
            exclusive jurisdiction of the courts in that location.
          </p>
          <h2 data-id="element-1508">10. Contact Information</h2>
          <p data-id="element-1509">
            If you have any questions about these Terms & Conditions, please
            contact me via the{' '}
            <Link to="/contact" className="text-[#0096B4] hover:underline" data-id="element-1510">
              Contact page
            </Link>
            .
          </p>
        </div>
      </section>
    </div>;
}